import React, { useEffect, useState } from "react";
import SimpleTable from "../../components/simple-table";
import { Box, Divider, Flex, Tr, Td, Text } from "@chakra-ui/react";
import MiniSideBar from "../../components/mini-sidebar";
import Loader from "../../components/loader/loader";
import SecondaryNav from "../../components/seconday-nav";
import useLoader from "../../components/loader/loaderstates";
import { DropdownInput, PrimaryButton, PrimaryInput } from "../../components";
import { formatDate_Do_MMM_YYYY } from "../../auth";
import { FetchPharmacyTransferReport } from "../../middleware/services/pharmacytransferreport";
import { FiCalendar, FiClock, FiUser } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";

const TransferPharmacyReport = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [totalItemCount, setTotalItemCount] = useState(0);
  let itemPerPageCommonValue = 50;
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);
  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [currentPage, setCurrentPage] = useState(1);
  let [totalPages, setTotalPages] = useState(1);
  let [pageno, setPageno] = useState(1);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState({
    medicineName: "",
    batchNumber: "",
    composition: "",
    medicineType: "",
  });

  const fetchData = async () => {
    showLoader();
    const pharmacyId = new URLSearchParams(window.location.search).get(
      "pharmacyid"
    );
    let input = {
      pharmacyid: pharmacyId || null,
    };
    try {
      const result = await FetchPharmacyTransferReport(input);
      console.log("result", result);
      if (result.result === "success") {
        setData(result.data);
      } 
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dismissLoader();
    }
  };

  const getFilteredResults = async (pagenoAttribute) => {
    showLoader();
    let input = {
      searchText: search || null,
      pageno: pagenoAttribute ? pagenoAttribute : pageno,
      pagesize,
    };
    try {
      const result = await FetchPharmacyTransferReport(input);
      // console.log("result", result);
      if (result.message === "success") {
        setData(result?.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count);
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);
        setTotalPages(totalPagesCount);
        if (count < itemPerPageCommonValue) {
          setCountTo(count);
          setTotalExceedsPageCount(true);
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }
      } else {
        setData(mockData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dismissLoader();
    }
  };

  const resetFeilds = () => {
    setSearch({
      medicineName: "",
      batchNumber: "",
      composition: "",
    });
    setData(mockData);
  };

  useEffect(() => {
    showLoader();
    // setData(mockData);
    fetchData();
    dismissLoader();
  }, []);

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNextClick = () => {
    let page = pageno + 1;
    setPageno(page);
    setCurrentPage(currentPage + 1);
    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize);
    } else {
      setCountTo(totalItemCount);
    }

    setCountFrom(countFrom + pagesize);
  };
  const handlePrevClick = () => {
    let page = pageno - 1;
    setPageno(page);
    setCurrentPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(
        Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue) *
          itemPerPageCommonValue
      );
    } else {
      setCountTo(countTo - pagesize);
    }

    setCountFrom(countFrom - pagesize);
  };

  const TableHeader = [
    { key: "productname", label: "Medicine Name" },
    { key: "strength", label: "Strength" },
    { key: "chemicalcomposition", label: "Chemical Composition" },
    { key: "manufacturer", label: "Manufacturer" },
    { key: "batchnumber", label: "Batch Number" },
    { key: "expirydate", label: "Expiry Date" },
  ];

  const mockData = [
    {
      inventoryid: 200,
      productcodeid: "123",
      productname: "Tocopherol",
      producttype: "Capsule",
      batchnumber: "BATCH2025",
      chemicalcomposition: "Tocopherol",
      dosage: "1 mg",
      receiveddate: "2025-01-24T00:00:00",
      receivedby: "john wick",
      storagecondition: "Cool",
      manufacturername: "Tocopherol",
      manufactureddate: "12-2024",
      suppliername: "Tocopherol",
      supplierdate: null,
      expirydate: "01-2039",
      costperunit: null,
      costperstrip: 1.0,
      costperbox: null,
      cgst: 1,
      sgst: 1,
      remainingquantity: 50,
      createddate: "2025-05-07T07:28:24.760",
      createdby: 1,
      modifieddate: null,
      modifiedby: null,
      isactive: 1,
      urn: null,
    },
    {
      inventoryid: 199,
      productcodeid: "43543",
      productname: "Dolo (560 mg)",
      producttype: "Tablet",
      batchnumber: "BATCH2026",
      chemicalcomposition: "Paracetamol 560mg",
      dosage: "560 mg",
      receiveddate: "2025-01-24T00:00:00",
      receivedby: "john wick",
      storagecondition: "Room Temperature",
      manufacturername: "dolo",
      manufactureddate: "01-2023",
      suppliername: "dolo",
      supplierdate: null,
      expirydate: "01-2032",
      costperunit: null,
      costperstrip: 1.0,
      costperbox: null,
      cgst: 0,
      sgst: 0,
      remainingquantity: 30,
      createddate: "2025-05-07T07:28:24.760",
      createdby: 1,
      modifieddate: null,
      modifiedby: null,
      isactive: 1,
      urn: null,
    },
    {
      inventoryid: 200,
      productcodeid: "123",
      productname: "Tocopherol",
      producttype: "Capsule",
      batchnumber: "BATCH2025",
      chemicalcomposition: "Tocopherol",
      dosage: "1 mg",
      receiveddate: "2025-01-24T00:00:00",
      receivedby: "john wick",
      storagecondition: "Cool",
      manufacturername: "Tocopherol",
      manufactureddate: "12-2024",
      suppliername: "Tocopherol",
      supplierdate: null,
      expirydate: "01-2039",
      costperunit: null,
      costperstrip: 1.0,
      costperbox: null,
      cgst: 1,
      sgst: 1,
      remainingquantity: 50,
      createddate: "2025-05-07T07:28:41.920",
      createdby: 1,
      modifieddate: null,
      modifiedby: null,
      isactive: 1,
      urn: null,
    },
    {
      inventoryid: 199,
      productcodeid: "43543",
      productname: "Dolo (560 mg)",
      producttype: "Tablet",
      batchnumber: "BATCH2026",
      chemicalcomposition: "Paracetamol 560mg",
      dosage: "560 mg",
      receiveddate: "2025-01-24T00:00:00",
      receivedby: "john wick",
      storagecondition: "Room Temperature",
      manufacturername: "dolo",
      manufactureddate: "01-2023",
      suppliername: "dolo",
      supplierdate: null,
      expirydate: "01-2032",
      costperunit: null,
      costperstrip: 1.0,
      costperbox: null,
      cgst: 0,
      sgst: 0,
      remainingquantity: 30,
      createddate: "2025-05-07T07:28:41.920",
      createdby: 1,
      modifieddate: null,
      modifiedby: null,
      isactive: 1,
      urn: null,
    },
    {
      inventoryid: 200,
      productcodeid: "123",
      productname: "Tocopherol",
      producttype: "Capsule",
      batchnumber: "BATCH2025",
      chemicalcomposition: "Tocopherol",
      dosage: "1 mg",
      receiveddate: "2025-01-24T00:00:00",
      receivedby: "john wick",
      storagecondition: "Cool",
      manufacturername: "Tocopherol",
      manufactureddate: "12-2024",
      suppliername: "Tocopherol",
      supplierdate: null,
      expirydate: "01-2039",
      costperunit: null,
      costperstrip: 1.0,
      costperbox: null,
      cgst: 1,
      sgst: 1,
      remainingquantity: 50,
      createddate: "2025-05-07T07:29:29.357",
      createdby: 1,
      modifieddate: null,
      modifiedby: null,
      isactive: 1,
      urn: null,
    },
    {
      inventoryid: 199,
      productcodeid: "43543",
      productname: "Dolo (560 mg)",
      producttype: "Tablet",
      batchnumber: "BATCH2026",
      chemicalcomposition: "Paracetamol 560mg",
      dosage: "560 mg",
      receiveddate: "2025-01-24T00:00:00",
      receivedby: "john wick",
      storagecondition: "Room Temperature",
      manufacturername: "dolo",
      manufactureddate: "01-2023",
      suppliername: "dolo",
      supplierdate: null,
      expirydate: "01-2032",
      costperunit: null,
      costperstrip: 1.0,
      costperbox: null,
      cgst: 0,
      sgst: 0,
      remainingquantity: 30,
      createddate: "2025-05-07T07:29:29.357",
      createdby: 1,
      modifieddate: null,
      modifiedby: null,
      isactive: 1,
      urn: null,
    },
  ];

  const gobackfunction = ()=>{
    window.history.back();
   }
  return (
    <>
      <Box w="100%">
        <Flex>
          <Box w="6rem">
            <MiniSideBar />
          </Box>
          {isLoading && <Loader />}
          <Box width="calc(100vw - 6.25rem)">
            <SecondaryNav withBack="Pharmacy Transfer Report" goBack={gobackfunction} />
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="start"
              alignItems="center"
            >
              <PrimaryInput
                variant="fullRound"
                title="Medicine Name"
                inputPlace="Medicine Name"
                id="searchProductName"
                name="medicineName"
                inputValue={search.medicineName}
                onChange={handleFilterInputChange}
              />

              <PrimaryInput
                variant="fullRound"
                title="Batch Number"
                inputPlace="Batch Number"
                id="searchBatchNumber"
                name="batchNumber"
                inputValue={search.batchNumber}
                onChange={handleFilterInputChange}
              />

              <PrimaryInput
                variant="fullRound"
                title="Composition"
                inputPlace="Composition"
                id="searchComposition"
                name="composition"
                inputValue={search.composition}
                onChange={handleFilterInputChange}
              />

              <PrimaryButton
                buttonText="Filter"
                id="filterButton"
                onClick={getFilteredResults}
                btnStyle={{ m: "0", w: "150px" }}
              />
              <PrimaryButton
                buttonText="Reset"
                id="resetButton"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                onClick={resetFeilds}
              />
            </Box>
            {/* <Box p="4" borderRadius="md" w="100%">
              <Flex justify="start" gap="4" wrap="wrap">
                <Flex justifyContent="center" alignItems="center" w='3rem' border='1px solid #e2e2e2' bg='#E6E7E966' borderRadius='8px'>
                  <Text fontSize="20px" textAlign='center' fontWeight="700" p='8px'>
                      15
                  </Text>
                </Flex>
                <Flex direction="column" mr="6">
                  <Flex align="center" gap="2">
                    <Box as={IoDocumentTextOutline} fontSize="18px" color="gray.600" />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      URN
                    </Text>
                  </Flex>
                  <Text ml='3px' fontSize="md" fontWeight="bold">
                    34234
                  </Text>
                </Flex>
                <Flex direction="column" mr="6">
                  <Flex align="center" gap="2">
                    <Box as={FiCalendar} fontSize="18px" color="gray.600" />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      DATE
                    </Text>
                  </Flex>
                  <Text fontSize="md" fontWeight="bold">
                    12 January 2025
                  </Text>
                </Flex>

                <Flex direction="column" mr="6">
                  <Flex align="center" gap="2">
                    <Box as={FiClock} fontSize="18px" color="gray.600" />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      TIME
                    </Text>
                  </Flex>
                  <Text fontSize="md" fontWeight="bold">
                    9:30 PM
                  </Text>
                </Flex>

                <Flex direction="column">
                  <Flex align="center" gap="2">
                    <Box as={FiUser} fontSize="18px" color="gray.600" />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      INITIATED BY
                    </Text>
                  </Flex>
                  <Text fontSize="md" fontWeight="bold">
                    Muneeb Rahmani
                  </Text>
                </Flex>
              </Flex>
            </Box> */}
            <Divider /> 
            {data && data.length > 0 ? (
              <>
                <Box
                  width="100%"
                  // p="1rem"
                  overflow="hidden auto"
                  h="calc(100vh - 100px)"
                >
                  <SimpleTable
                    headers={TableHeader}
                    className="tableContainer"
                    isDataPresent={true}
                    // ref={tableRef}
                    footerStyle={{
                      pos: "fixed",
                      bottom: "0px",
                      left: "100px",
                      boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    }}
                    tableStyle={{
                      maxH: "calc(100vh - 75px)",
                      overflowY: "auto",
                      tableLayout: "fixed",
                      width: "100%",
                    }}
                    tableBody={
                      <>
                        {data.map((item, index) => (
                          <Tr w="100%" index={index}>
                            <Td
                              display="flex"
                              gap={"0.5rem"}
                              alignItems="center"
                            >
                              <Text>{item.productname}</Text>
                              <Box
                                as="span"
                                bg="#E6E7E966"
                                mr="0.25rem"
                                border="1px solid #E6E7E9"
                                borderRadius="8px"
                                fontSize="10px"
                                px="8px"
                              >
                                {item.producttype}
                              </Box>
                            </Td>
                            <Td>
                              <Text>{item.dosage}</Text>
                            </Td>
                            <Td>
                              <Text>{item.chemicalcomposition}</Text>
                            </Td>
                            <Td>
                              <Text>{item.manufacturername}</Text>
                            </Td>
                            <Td>
                              <Text>{item.batchnumber}</Text>
                            </Td>
                            <Td>
                              <Text>
                                {formatDate_Do_MMM_YYYY(item.receiveddate)}
                              </Text>
                            </Td>
                            
                          </Tr>
                        ))}
                      </>
                    }
                    // footerSection={
                    //   <>
                    //     {data && data.length > 0 && (
                    //       <Tr w="100%">
                    //         <Td colSpan={11} w="calc(100vw - 6.5rem)">
                    //           <Box
                    //             w="100%"
                    //             display="flex"
                    //             justifyContent="space-between"
                    //             alignItems="center"
                    //           >
                    //             <Box
                    //               visibility={
                    //                 totalItemCount < countTo &&
                    //                 !totalExceedsPageCount
                    //                   ? "hidden"
                    //                   : "visible"
                    //               }
                    //             >
                    //               <Text>
                    //                 Showing <b>{countFrom}</b> to{" "}
                    //                 {/* Showing <b>1</b> to <b>2</b> of 20 results */}
                    //                 <b>{countTo}</b> of {totalItemCount} results
                    //               </Text>
                    //             </Box>

                    //             <Box
                    //               gap="2.5rem"
                    //               display="flex"
                    //               justifyContent="space-between"
                    //               alignItems="center"
                    //             >
                    //               <Box
                    //                 as="button"
                    //                 onClick={handlePrevClick}
                    //                 disabled={currentPage == 1}
                    //                 visibility={
                    //                   currentPage == 1 ? "hidden" : "visible"
                    //                 }
                    //                 p="0.5rem 0.75rem"
                    //                 border="0.0625rem solid #E6E7E9"
                    //                 borderRadius="0.75rem"
                    //                 fontSize=".875rem"
                    //                 fontWeight="500"
                    //               >
                    //                 Previous
                    //               </Box>
                    //               <Box>
                    //                 <Text
                    //                   textAlign="center"
                    //                   fontSize=".875rem"
                    //                   fontWeight="600"
                    //                 >
                    //                   Page {currentPage} of {totalPages}
                    //                   {/* Page 1 of 20 */}
                    //                 </Text>
                    //               </Box>
                    //               {totalItemCount >= countTo &&
                    //                 !totalExceedsPageCount && (
                    //                   <Box
                    //                     as="button"
                    //                     p="0.5rem 0.75rem"
                    //                     mr="2.5rem"
                    //                     border="0.0625rem solid #E6E7E9"
                    //                     borderRadius="0.75rem"
                    //                     onClick={handleNextClick}
                    //                     disabled={currentPage == totalPages}
                    //                     visibility={
                    //                       currentPage == totalPages
                    //                         ? "hidden"
                    //                         : "visible"
                    //                     }
                    //                     fontSize=".875rem"
                    //                     fontWeight="500"
                    //                   >
                    //                     Next
                    //                   </Box>
                    //                 )}
                    //             </Box>
                    //           </Box>
                    //         </Td>
                    //       </Tr>
                    //     )}
                    //   </>
                    // }
                  />
                </Box>
              </>
            ) : (
              <Box width="100%">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py="2rem"
                >
                  <Text fontSize="md" fontWeight="bold">
                    No Pharmacy Found
                  </Text>
                </Box>
              </Box>
            )}
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default TransferPharmacyReport;
